export default __webpack_public_path__ + "static/media/49.ad5f725e.jpeg";